import { useState, useContext, useEffect, } from "react";
import Button from "../../../components/Common/Button";
import styles from './style.module.css'
import { useNavigate, useLocation } from "react-router-dom";
import mainContext from "../../../context/mainContext";
import Input from "../../../components/Common/Input/Input";
import { validate } from "../../Signup/Signup/validate";
import underline from '../../../assets/images/icons/UnderLine.png'

export default function FourQues() {
    const { header } = useContext(mainContext)
    const location = useLocation();
    const navigateObject = location.state.navigateObject;
    const navigate = useNavigate();
    const [valid, setValid] = useState([]);
    const [validLength, setValidLength] = useState(8)

    const getDatafromForm = (formData) => ({
        1: formData.get("1"),
        2: formData.get("2"),
        3: formData.get("3"),
        4: formData.get("4"),
        5: formData.get("5"),
        6: formData.get("6"),
        // 7: formData.get("7"),
        // 8: formData.get("8"),
    })


    useEffect(() => {
        header.setPageName(`PUSHUP Round ${navigateObject.roundCounter}/4 JOURNAL`);
        return () => header.setPageName(``);
    }, [])


    function handleSubmit(e) {
        e.preventDefault()

        const body = getDatafromForm(new FormData(e.currentTarget))
        const checkResult = validate(body)
        setValid(checkResult)

        if (checkResult.length) return;

        navigateObject.roundCounter++;

        let question = {
            type: "pushUp",
            answer: {
                1: body["1"], 2: body["2"], 3: body["3"], 4: body["4"],
                5: body["5"], 6: body["6"],
                //  7: body["7"], 8: body["8"] 
            }
        }

        navigateObject.questions.push(question)

        if (navigateObject.roundCounter <= 4) {
            console.log("not 4", navigateObject);
            localStorage.Epage = question.answer["6"];
            navigate("/train-reading/pushup", { state: { navigateObject } })
        } else {
            console.log("4+", navigateObject);
            localStorage.Epage = question.answer["6"];
            navigate("/train-reading/level-exercise", { state: { navigateObject } })
            // navigate("/tr/exercise", { state: { navigateObject } })
        }
    }
    const checkValid = (e) => {
        e.preventDefault();
        const body = getDatafromForm(new FormData(e.currentTarget))
        const checkResult = validate(body)
        setValidLength(checkResult.length)
    }

    return (
        <div className="container" style={{ flexGrow: 1 }}>            {/* //TODO:majorCSSChange*/}
            <div className={styles.QTitle}>What did you see? What did you feel?</div>
            <div className={styles.nTitle}>{navigateObject.bookName}</div>
            <img src={underline} className={styles.nUnderLine} alt="" />
            {/* <div className={styles.newText}>{`Beginning Page: ${navigateObject.Bpage}, Ending Page: ${navigateObject.Epage}. `}</div> */}
            <form onChange={checkValid} onSubmit={handleSubmit} className={styles.fourQues} style={window.buildType === "iPhone" ? { height: "67vh", overflowY: "scroll" } : {}}>
                {/* <div className={styles.questionsContainer}> */}                {/* //TODO:majorCSSChange*/}
                <div className={styles.pageRangeContainer}>
                    <div style={window.buildType === "iPhone" ? { width: "35%" } : {}}>
                        <Input name={"5"} legend={"From Page"} type="number" defaultValue={localStorage.Epage ? localStorage.Epage : ""} content="Num." valid={!valid.includes("5")} />
                    </div>
                    <div style={window.buildType === "iPhone" ? { width: "35%" } : {}}>
                        <Input name={"6"} legend={"To Page"} type="number" content="Num." valid={!valid.includes("6")} />
                    </div>
                </div>
                <Input name={"1"} legend={"Who?"} type="text" content="Describe Here" valid={!valid.includes("1")} />
                <Input name={"2"} legend={"What?"} type="text" content="Describe Here" valid={!valid.includes("2")} />
                <Input name={"3"} legend={"Where?"} type="text" content="Describe Here" valid={!valid.includes("3")} />
                <Input name={"4"} legend={"When?"} type="text" content="Describe Here" valid={!valid.includes("4")} />
                {/* </div> */}                {/* //TODO:majorCSSChange*/}
                <Button disabled={validLength != 0} title="DONE" fontColor="white" height="50px" />
            </form>
        </div>//TODO:majorCSSChange*/
    )
}